export const colors = {
    greenSelected: '#27AE60',
    whiteSelected: '#F1F2F9',
    bgLight: '#313237',
    bgDark: '#905BFF',
    bgMiddleDark: '#4A4D58',
    whiteDefault: '#fff',
    bgSelectedDark: '#323542',
    borderSelected: '#E2E6E9',
    hoverDark: '#A378FF',
    iconsBorderDefaultLight: '#B4BDC3',
    iconsBorderHoverLight: '#313237',
    iconsBorderSelectedLight: '#E2E6E9',
    iconsBorderDefaultDark: '#B4BDC3',
    iconsBorderHoverDark: '#313237',
    iconsBorderSelectedDark: '#3B3E4A',
    breadcrumbsLight: '#89939A',
    breadcrumbsDark: '#F1F2F9',
    breadcrumbsHoverLight: '#313237',
    breadcrumbsHoverDark: '#905BFF',
  }